const global = window

global.delayedInput = 0;
const inputs = {
    registered: {},
    contextual: {},
    types: {},
    typesDelay: {},
    fn: {},
    alias: {},
    behavior: {},
    stack: [],
    stackTimeout: null,
}
global.inputs = inputs;

global.registerInput = function (name, type, dataOpt) {
    type = type.charAt(0).toLowerCase() + type.slice(1)
    if (inputs.typesDelay[type]) {
        inputs.stack.push({
            name,
            type,
            dataOpt,
        })
    } else {
        registerInputProcess(name, type, dataOpt)
    }

    if (inputs.stack.length > 0 && !inputs.stackTimeout) {
        inputs.stackTimeout = setTimeout(registerInputStack, 1);
    }
}

global.registerInputStack = function (noRelaunch) {
    inputs.stackTimeout = null;
    if (inputs.stack.length > 0) {
        const data = inputs.stack.shift();
        const input = typeof data.name === 'string' ? $('#' + data.name) : $(data.name);
        if (input.length) {
            registerInputProcess(data.name, data.type, data.dataOpt);
            if (!noRelaunch) {
                inputs.stackTimeout = setTimeout(registerInputStack, 0);
            }
        } else {
            registerInputStack();
        }
    }
}

global.registerInputProcess = function (name, type, dataOpt) {
    let data = dataOpt
    const realName = data && data.name ? data.name : null
    // console.log('INPUT : ' + type + ' ' + name);
    let input;
    if (typeof name === 'string') input = $('#' + name)
    else input = $(name);
    if (!input.length) return false
    const parent = input.parent()
    input.data('data', data)
    const inputWindow = input.closest('[data-api], .window, body')
    const niceName = data.id != name && data.id ? data.id : data.name
    data.html = input
    type = type.charAt(0).toLowerCase() + type.slice(1)

    if (input.data('registered') === true) return false;

    // precopy data
    input.data('data', data);

    /*
    if (realName && (inputs.contextual[realName] || inputs.contextual[realName] === 0)) {
        data.value = inputs.contextual[realName];
        console.log(realName + ' - ' + inputs.contextual[realName]);
    }
    */

    // inputWindow identifier
    if (!inputWindow.data('behavkey')) {
        if (inputWindow.is('body')) {
            inputWindow.data('behavkey', 'root')
        }
        else {
            inputWindow.data('behavkey', ((inputWindow.attr('id')) ? formatFilename(inputWindow.attr('id')) + '_' : '') + generateRandomString(20))
        }
    }

    // types
    let typeRef = data.type
    if (!inputs.alias[typeRef] && !inputs.types[typeRef]) typeRef = type
    if (inputs.alias[typeRef]) typeRef = inputs.alias[typeRef]
    if (inputs.types[typeRef]) {
        const typeFn = inputs.types[typeRef];
        data = typeFn(data, name, niceName, type, input, parent, inputWindow);
    }

    // behaviors
    const behaviorKeys = Object.keys(inputs.behavior);
    behaviorKeys.forEach((key) => {
        const behaviorFn = inputs.behavior[key];
        data = behaviorFn(data, name, niceName, type, input, parent, inputWindow);
    });

    inputs.registered[name] = data

    // event change
    if (data.onChange) {
        input.change(function (event) {
            eval(data.onChange);
        })
    }

    // redundancy
    if (data.redundancy) {
        input.data('redundancy', data.redundancy)
    }

    // min
    if (data.min) {
        input.data('min', data.min)
    }

    // max
    if (data.max) {
        input.data('max', data.max)
    }

    // test
    if (data.test) {
        input.data('test', data.test)
        input.change(function () {
            $(this).removeClass('tested')
            $(this).removeClass('tested--success')
            $(this).removeClass('tested--error')
        })
    }

    // Backup original data
    data.valueLast = getFieldData(data.name, parent)

    // data
    input.data('data', data);
    if (data.data) {
        $.each(data.data, function (key, value) {
            input.data(key, value);
        });
    }

    // registration
    input.data('registered', true)
}

global.inputReloadParent = function (input) {
    if (typeof input === 'string') {
        if (typeof global.refreshTargets === 'function') {
            global.refreshTargets(input);
        } else {
            let targetEl = $('#' + input + ', [data-name="' + input + '"]').filter('.ajaxable');
            if (!targetEl.length) {
                targetEl = $('#' + input + ', [data-name="' + input + '"]');
            }
            if (targetEl.length && targetEl.data('data') && typeof targetEl.data('data').reload === 'function') {
                targetEl.data('data').reload();
            }
        }
        return;
    }

    const inputData = $(input).data('data');
    let popupObj = (inputData && inputData.popup) ? inputData.popup : $(input).data('popup');
    if (typeof popupObj === 'string') {
        try { popupObj = JSON.parse(popupObj); } catch(e) { popupObj = null; }
    }
    let refreshTargets = popupObj && popupObj.refresh ? popupObj.refresh : null;
    if (!refreshTargets) {
        refreshTargets = (inputData && inputData.refresh) ? inputData.refresh : $(input).data('refresh');
        if (typeof refreshTargets === 'string') {
            try {
                refreshTargets = JSON.parse(refreshTargets);
            } catch (e) {
                refreshTargets = [refreshTargets];
            }
        }
    }

    if (refreshTargets) {
        if (typeof global.refreshTargets === 'function') {
            global.refreshTargets(refreshTargets, input);
        } else {
            const targets = Array.isArray(refreshTargets) ? refreshTargets : [refreshTargets];
            const pf = $(input).closest('.window, body');
            targets.forEach((targetName) => {
                let targetEl = pf.find('#' + targetName + ', [data-name="' + targetName + '"]').filter('.ajaxable');
                if (!targetEl.length) {
                    targetEl = $('#' + targetName + ', [data-name="' + targetName + '"]').filter('.ajaxable');
                }
                if (!targetEl.length) {
                    targetEl = pf.find('#' + targetName + ', [data-name="' + targetName + '"]');
                }
                if (!targetEl.length) {
                    targetEl = $('#' + targetName + ', [data-name="' + targetName + '"]');
                }
                if (targetEl.length && targetEl.data('data') && targetEl.data('data').reload) {
                    targetEl.data('data').reload();
                }
            });
        }
        return;
    }

    let container = $(input).closest('.grid')
    if (!container.hasClass('ajaxable')) {
        let parent = container.closest('.ajaxable')
        if (parent.length > 0) container = parent;
        else {
            let childs = container.find('.ajaxable')
            if (childs.length > 0) container = childs;
        }
    }
    if (container.length && container.data('data') && container.data('data').reload) container.data('data').reload()
}
